import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import { latestByYear } from "@/lib/media";

export default function LatestSection() {
  const panels = [
    {
      title: "最新电影",
      subtitle: "Latest Movies",
      to: "/movies",
      items: latestByYear("movie", 3),
    },
    {
      title: "最新电视剧",
      subtitle: "Latest Series",
      to: "/tvshows",
      items: latestByYear("tv", 3),
    },
  ];

  return (
    <section className="bg-background-100/40 py-12 md:py-16">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新上映
            </h2>
            <p className="mt-1.5 text-sm text-foreground-500">
              紧跟院线与平台热度，第一时间发现新片好剧
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-10">
          {panels.map((panel) => (
            <div key={panel.title}>
              <div className="mb-4 flex items-center justify-between border-b border-background-200/60 pb-3">
                <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-900">
                  <span className="h-4 w-1 rounded-full bg-primary-500"></span>
                  {panel.title}
                  <span className="text-xs font-normal uppercase tracking-wider text-foreground-500">
                    {panel.subtitle}
                  </span>
                </h3>
                <Link
                  to={panel.to}
                  className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-500"
                >
                  更多
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4">
                {panel.items.map((item) => (
                  <MediaCard key={item.id} media={item} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}